import BoldChevronLeftIcon from '~/components/icons/BoldChevronLeftIcon.jsx';
import BoldChevronRightIcon from '~/components/icons/BoldChevronRightIcon.jsx';
import { format } from 'date-fns';
import { formatDate } from '~/lib/DateTime.js';

const HeadingPreviousNext = ({
    children,
    start,
    end,
    onNext,
    onPrevious,
    className,
}) => {
    return (
        <div className={`flex items-center ${className}`}>
            <div className="flex items-center space-x-0.5">
                <button
                    type="button"
                    onClick={onPrevious}
                    className="themed-bg-light themed-text flex justify-end items-center rounded-l-full"
                >
                    <BoldChevronLeftIcon className="w-8 h-8" />
                </button>
                <button
                    type="button"
                    onClick={onNext}
                    className="themed-bg-light themed-text text-center rounded-r-full"
                >
                    <BoldChevronRightIcon className="w-8 h-8" />
                </button>
            </div>
            <div className="font-xl font-bold ml-4">
                {!!children && children}
                {!children && (
                    <>
                        {formatDate(start)} - {formatDate(end)}
                    </>
                )}
            </div>
        </div>
    );
};

export default HeadingPreviousNext;
